import { gql } from '@apollo/client';

export const GetMyMcpAccess = gql`
  query GetMyMcpAccess {
    myMcpAccess {
      enabled
      endpoint
      blockedReason
      callsLast30Days
      connections {
        id
        application
        scope
        created
        expires
        lastUsed
      }
    }
  }
`;
